import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarkCircle } from '@fortawesome/pro-solid-svg-icons/faXmarkCircle';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { useTranslateImportSummaryError } from '../../../../hooks/use-translate-import-summary-error/use-translate-import-summary-error';
import { useImportContext } from '../../../import-context';
import { messages } from '../messages';
import styles from './styles.module.css';

/**
 * Renders a summary row for a specific error
 * @param {object} props
 * @param {import("../../../../../data/types/types").ImportErrorInfo} props.error
 * @returns {JSX.Element}
 */
export const SummaryErrorRow = ({ error }) => {
  const { translateField } = useImportContext();

  const severity = <FormattedMessage {...(error.severity === 'error' ? messages.error : messages.warning)} />;
  const summaryError = useTranslateImportSummaryError(error);
  const attributeCode = error.attributeCode ? translateField(error.attributeCode) : '';

  return (
    <div className={styles['error-row-wrapper']}>
      {error.severity === 'error' ? (
        <FontAwesomeIcon className={styles['icon-error']} icon={faXmarkCircle} />
      ) : (
        <FontAwesomeIcon className={styles['icon-warning']} icon={faExclamationTriangle} />
      )}
      {summaryError ? (
        <Text
          className={styles['error-message']}
          formattedMessageValues={{
            rowNumber: error.rowNum,
            severity,
            description: summaryError,
            attributeCode,
          }}
          value={messages.summaryMessage}
        />
      ) : (
        <Text
          formattedMessageValues={{
            rowNum: error.rowNum,
            message: error.message,
          }}
          textType={TextType.Paragraph}
          value={messages.rowErrorDetails}
        />
      )}
    </div>
  );
};

SummaryErrorRow.propTypes = {
  error: PropTypes.object.isRequired,
};
